import { useGetRegularAssessments } from "@/api/console/regular-assessments/useGetRegularAssessments";
import ActiveAssesmentTable from "@/src/console/(auth)/(manage-assessments)/regular-assessments/_components/ActiveAssessmentTable";
import Heading from "@/src/console/(auth)/(manage-assessments)/regular-assessments/_components/Heading";
import PreviousAssessmentTable from "@/src/console/(auth)/(manage-assessments)/regular-assessments/_components/PreviousAssessmentTable";

function RegularAssessment() {
  const { data, isLoading } = useGetRegularAssessments();
  const assessments = data?.data || [];

  const currentActiveTest = assessments.find(
    (assessment) => assessment.is_published,
  );
  const previousTests = assessments.filter(
    (assessment) =>
      assessment.is_published && assessment.id !== currentActiveTest?.id,
  );

  const draftTest = assessments.find((assessment) => !assessment.is_published);

  const activeTests = currentActiveTest ? [currentActiveTest] : [];

  return (
    <div>
      <Heading draftTest={draftTest} currentActiveTest={currentActiveTest} />
      <div className="mx-6 flex flex-col gap-8">
        <ActiveAssesmentTable isLoading={isLoading} activeTests={activeTests} />
        <PreviousAssessmentTable
          isLoading={isLoading}
          previousTests={previousTests}
        />
      </div>
    </div>
  );
}

export default RegularAssessment;
